// extracted by mini-css-extract-plugin
export default {"divMain":"SmallContact_divMain__G9iaG","divIcon":"SmallContact_divIcon__vH2D1"};